import { render, staticRenderFns } from "./Reg375.vue?vue&type=template&id=31bba5de"
import script from "./Reg375.vue?vue&type=script&lang=js"
export * from "./Reg375.vue?vue&type=script&lang=js"
import style0 from "./Reg375.vue?vue&type=style&index=0&id=31bba5de&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports